import { JsonRepository } from '../../JsonRepository';
import { getFaqData } from '../../../../data/faq-data';
import { FaqCategory } from '../../../../domain/models/Customer/faq';

export class FaqRepository extends JsonRepository {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getFaqQuestions = async (country: string, site: string, currency: string, customerPhone: string) => {
    this.data = getFaqData(site, currency, customerPhone);
    return await this.list({ country });
  };
}
